import type { ValueOf } from "@packall/core";

/** How one "this file already exists" question was answered. */
export const OverwriteAnswer = {
	Overwrite: "overwrite",
	Keep: "keep",
	/** Replace this one and stop asking for the rest of the run. */
	Always: "always",
} as const;

export type OverwriteAnswer = ValueOf<typeof OverwriteAnswer>;
